export var JourneyStatus;
(function (JourneyStatus) {
    JourneyStatus["ACTIVE"] = "active";
    JourneyStatus["PAUSED"] = "paused";
    JourneyStatus["COMPLETED"] = "completed";
    JourneyStatus["ABANDONED"] = "abandoned";
})(JourneyStatus || (JourneyStatus = {}));
export var SkillLevel;
(function (SkillLevel) {
    SkillLevel["BEGINNER"] = "beginner";
    SkillLevel["INTERMEDIATE"] = "intermediate";
    SkillLevel["ADVANCED"] = "advanced";
})(SkillLevel || (SkillLevel = {}));
export var ActivityType;
(function (ActivityType) {
    ActivityType["VIDEO"] = "video";
    ActivityType["RECIPE"] = "recipe";
    ActivityType["READING"] = "reading";
    ActivityType["QUIZ"] = "quiz";
    ActivityType["PRACTICE"] = "practice";
})(ActivityType || (ActivityType = {}));
export var ActivityProgressStatus;
(function (ActivityProgressStatus) {
    ActivityProgressStatus["NOT_STARTED"] = "not_started";
    ActivityProgressStatus["IN_PROGRESS"] = "in_progress";
    ActivityProgressStatus["COMPLETED"] = "completed";
    ActivityProgressStatus["SKIPPED"] = "skipped";
})(ActivityProgressStatus || (ActivityProgressStatus = {}));
export var ContentKind;
(function (ContentKind) {
    ContentKind["RECIPE"] = "recipe";
    ContentKind["VIDEO"] = "video";
    ContentKind["ARTICLE"] = "article";
    ContentKind["QUIZ"] = "quiz";
})(ContentKind || (ContentKind = {}));
export var DifficultyPreference;
(function (DifficultyPreference) {
    DifficultyPreference["EASY"] = "easy";
    DifficultyPreference["MODERATE"] = "moderate";
    DifficultyPreference["CHALLENGING"] = "challenging";
})(DifficultyPreference || (DifficultyPreference = {}));
export var ContentType;
(function (ContentType) {
    ContentType["VIDEO"] = "video";
    ContentType["RECIPE"] = "recipe";
    ContentType["READING"] = "reading";
    ContentType["QUIZ"] = "quiz";
    ContentType["PRACTICE"] = "practice";
})(ContentType || (ContentType = {}));
export var LearningStyle;
(function (LearningStyle) {
    LearningStyle["VISUAL"] = "visual";
    LearningStyle["HANDS_ON"] = "hands_on";
    LearningStyle["READING"] = "reading";
    LearningStyle["MIXED"] = "mixed";
})(LearningStyle || (LearningStyle = {}));
export var JourneyNotificationFrequency;
(function (JourneyNotificationFrequency) {
    JourneyNotificationFrequency["DAILY"] = "daily";
    JourneyNotificationFrequency["WEEKLY"] = "weekly";
    JourneyNotificationFrequency["CUSTOM"] = "custom";
})(JourneyNotificationFrequency || (JourneyNotificationFrequency = {}));
export var JourneyNotificationType;
(function (JourneyNotificationType) {
    JourneyNotificationType["ACTIVITY_REMINDER"] = "activity_reminder";
    JourneyNotificationType["STREAK_REMINDER"] = "streak_reminder";
    JourneyNotificationType["MILESTONE"] = "milestone";
    JourneyNotificationType["NEW_CONTENT"] = "new_content";
})(JourneyNotificationType || (JourneyNotificationType = {}));
